<template>
	<v-app>
		<router-view></router-view>
		<v-snackbar :timeout="5000" :color="snackbar.color"
			:top="true" :right="true" v-model="snackbar.isVisible">
			{{ snackbar.text }}
			<v-btn flat class="white--text" @click.native="snackbar.isVisible = false">Cerrar</v-btn>
		</v-snackbar>
	</v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

function snackbar() {
	return this.$store.getters.snackbar;
}

function created() {
	const adminUser = JSON.parse(localStorage.getItem(`${process.env.STORAGE_USER_KEY}::adminUser`));
	if (!this.userName && adminUser) {
		this.setUser(adminUser);
	}
}

export default {
	name: 'app',
	created,
	computed: {
		snackbar,
		...mapGetters('user', [
			'userName',
		]),
	},
	methods: {
		...mapActions('user', [
			'setUser',
		]),
	},
};
</script>

<style lang="scss">
@import 'customization';

html {
	font-size: 16px;

	* {
		outline: none !important;
	}
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.content {
	background: map-get($colors, white);
	padding: 133px 12px 0px !important;

	&--wrap {
		background-color: map-get($colors, white);
		padding: 0px 12px;
	}

	@media (min-width: 768px) {
		padding: 80px 0px 0px !important;
	}

	@media (min-width: 1264px) {
		padding: 80px 0px 0px 53px !important;
	}
}

.chk-all {
	&.v-input-group {
		.v-input-group__input {
			.icon {
				font-size: 18px !important;
				height: 18px;
			}
		}
		.v-input-group__details {
			display: none;
		}
	}
}

.bars-align {
	max-width: 100%;
	.v-list__tile {
		justify-content: flex-end;
		padding-left: 6px;
		&__title {
			color: color(green-icon) !important;
		}

		&--avatar {
			height: 100px;
			background-color: #02979b !important;
		}
	}

	.v-btn {
		color: color(secondary) !important;
	}
}

.v-snack {
	.v-btn {
		color: map-get($colors, white) !important;
	}
}

.pa-0 {
	main.content {
		padding: 0px !important;
	}
}

.progress-bar {
	left: 0px !important;
	margin: 0px !important;
	position: absolute !important;
	right: 0px !important;
	top: 120px !important;

	@media (min-width: 768px) {
		top: 42px !important;
	}
}

.sidebar-bg {
	&.v-list {
		.v-list__group {
			&__header {
				&__prepend-icon,
				&__append-icon {
					display: none;
				}

				&:hover {
					background: transparent;
				}

				.v-list__tile {
					font-family: font(AvenirRegular);
					font-size: 13px;
					height: 40px;
					padding: 0 19px 0 18px;
					text-transform: uppercase;
					&:hover,
					&--active {
						background: transparent;
						opacity: 1;
						background-color: #02979b !important;
					}
				}

				&--active {
					.v-list__tile {
						opacity: 1;
						background: #02979b;
					}
				}
			}

			&__items {
				&.padding-items {
					padding-bottom: 12px;
				}

				.v-list__tile {
					font-family: map-get($fonts, open-regular);
					font-size: 12px;
					height: 40px;
					padding: 0 0 0 26px;
					background-color: #03888c !important;
					&:hover {
						background: transparent;
						opacity: 1;
						background-color: #03888c !important;
					}

					&__action {
						color: map-get($colors, white);
						justify-content: flex-start;
						align-items: initial;
						min-width: 26px;
						.v-icon {
							color: inherit !important;
							font-size: 6px;
						}
					}

					&--active {
						font-weight: bold;
						color: #fff;
						.v-list__tile__title {
							font-size: 13px;
						}
					}

					&__content {
						color: map-get($colors, white);
					}
				}
			}

			&:before,
			&:after {
				background: rgba(0, 0, 0, 0.12);
			}
		}

		.v-list__group--active {
			background-color: color(green-dark-icon);

			.v-list__group__header--active {
				box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
			}
		}
	}
}

.char-value-select {
	&.input-group {
		.input-group__input {
			.icon {
				font-size: 18px !important;
				height: 18px;
			}
		}

		label {
			color: map-get($colors, black) !important;
			font-size: 13px;
		}
	}
}

.sidebar-border {
	background-color: #02979b!important;
	margin-top: 40px !important;
	z-index: 205;
	.v-toolbar__content {
		padding: 0px;
		background-color: #02979b!important;
		height: 30px !important;
		.v-list {
			margin: 0px;
			max-width: 100%;
			padding: 0px;
		}
	}
	.v-navigation-drawer__border {
		background-color: #02979b!important;
		width: 3px;
	}

	.v-list__tile {
		height: 31px;
		color: inherit;
		&__title {
			align-items: center;
			display: flex;
			color: inherit;
			font-size: size(small);
			font-family: Opens_regular;
		}
		&__action {
			justify-content: flex-end;
		}

		.icon-sidebar {
			width: 16px;
		}
	}

	.v-list__group__header {
		.v-list__tile {
			&__action {
				min-width: auto;
				justify-content: flex-start;
			}
		}
	}

	&.v-navigation-drawer--mini-variant {
		.v-list__tile {
			padding: 12px !important;

			&__action {
				justify-content: center !important;
				min-width: 100%;
			}
		}

		.v-list__group__header {
			.v-list__tile {
				padding: 0px !important;

				&__action {
					min-width: 100%;
					justify-content: center;

					.v-icon {
						color: inherit !important;
					}
				}

				&__content {
					display: none;
				}
			}
		}

		@media (max-width: 768px) {
			left: -54px;
		}
	}
}

.v-toolbar__content {
	.v-list {
		&:first-child {
			margin-left: 0px !important;
		}
	}
}
.v-toolbar__content {
	background-color: #fff !important;
}
.columns-menu {
	&.v-menu__content {
		background-color: white;
		border-radius: 4px;
		box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.4);
		max-width: 154px;
		padding-left: 5px;
		padding-right: 5px;

		.v-input {
			label {
				color: map-get($colors, subheaderText);
				font-family: map-get($fonts, opens-semibold);
				font-size: 13px;
				line-height: 21px;
			}

			&__input {
				min-height: 20px;
			}

			.v-icon {
				font-size: map-get($sizes, medium);
				height: 5px !important;
			}

			&--selection-controls {
				margin-top: 0px;
			}

			&--selection-controls__input {
				height: 14px;
				width: 14px;
			}

			&--selection-controls__ripple {
				height: 10px;
				transform: translate(7px, 12px);
				width: 10px;
			}
		}

		.apply {
			border-top: 1px solid #e5e5e5;
			margin-top: 5px;

			button {
				color: map-get($colors, info);
				font-family: map-get($fonts, opens-semibold);
				font-size: 13px;
				outline: none;
			}
		}
	}
}
// Aqui

.filter-select {
	&.v-input {
		background: white;
		border: 1px solid #a9bac2;
		border-radius: 5px;
		height: 31px;
		padding: 0px;

		&.shadow-inset {
			&-chip {
				border-radius: 5px;
				box-shadow: inset 0px 0px 1px 0px rgba(0, 0, 0, 0.5);
				height: 30px;
				left: 16px;
				max-width: 160px;
				position: absolute;
				top: 1.5px;

				input {
					color: map-get($colors, subheaderText);
					font-family: map-get($fonts, open-semibold);
					font-size: map-get($sizes, medium);
					padding: 0 19px;
					text-align: right;
				}

				label {
					color: map-get($colors, subheaderText);
					font-family: map-get($fonts, open-semibold);
					font-size: map-get($sizes, medium);
					height: 30px;
					left: auto;
					line-height: 30px;
					text-align: right;
					right: 19px;
				}
			}

			&-table {
				border-radius: 3px;
				box-shadow: none;
				display: inline-flex;
				height: 22px;
				max-width: 72px;

				.v-input-group__input {
					min-height: 22px;
				}

				input {
					border-radius: 3px;
					box-shadow: inset 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
					color: map-get($colors, paginationText);
					font-size: map-get($sizes, small);
					height: 22px;
					padding: 0 5px;
					text-align: right;
				}

				label {
					color: map-get($colors, subheaderText);
					font-size: map-get($sizes, medium);
					height: 22px;
					left: auto;
					line-height: 22px;
					text-align: right;
					right: 5px;
				}
			}

			.v-input-group__selections {
				border-width: 1px;
				height: 24px;

				&__comma {
					color: map-get($colors, paginationText) !important;
				}
			}

			.v-input-group__append-icon {
				width: 26px;
			}

			input {
				color: color(text) !important;
				font-family: map-get($fonts, open-semibold);
				font-size: map-get($sizes, medium);
				height: 31px;
				padding: 0px 0px 0px 14px;

				&[readonly] {
					color: map-get($colors, subheaderText) !important;
				}
			}

			label {
				color: map-get($colors, paginationText) !important;
				height: 30px;
				line-height: 30px;
			}

			&-calendar {
				.v-icon {
					background: map-get($colors, orange-btn);
					border-bottom-right-radius: 2px;
					border-top-right-radius: 2px;
					color: white !important;
					font-size: 24px;
					height: 30px;
					line-height: 32px;
					padding-left: 3px;
					width: 30px;
				}

				&.shadow-inset-calendar-start {
					.icon {
						background: map-get($colors, success);
					}
				}

				&.shadow-inset-calendar-start,
				&.shadow-inset-calendar-end {
					.icon {
						height: 28px;
						line-height: 30px;
					}
				}

				&.shadow-inset-calendar-requirement {
					.icon {
						background: white;
						border: 1px solid map-get($colors, blue-purchase);
						color: map-get($colors, blue-purchase) !important;
						height: 28px;
						line-height: 30px;
					}
				}
			}

			&.input-address {
				.input-group__input {
					padding-right: 7px;
				}

				.input-group__append-icon {
					background-color: map-get($colors, orange-btn);
					border-radius: 4px;
					box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3);
					color: white !important;
					font-size: 16px;
					height: 20px;
					padding-top: 2px;
					text-align: center;
					width: 20px;
				}
			}

			&.input-time-picker {
				.input-group--text-field__suffix {
					color: map-get($colors, paginationText) !important;
					font-family: map-get($fonts, open-semibold);
					font-size: map-get($sizes, medium);
					height: 28px;
					margin: 0px;
					padding-right: 20px;
				}
			}

			&.textarea-content {
				border: none !important;
				min-height: 85px;

				label {
					top: 5px;
				}

				.input-group__input {
					border: none !important;
				}

				textarea {
					padding-left: 16px;
					padding-top: 7px;
				}
			}
		}

		&--autocomplete {
			input {
				color: map-get($colors, subheaderText);
				font-size: 13px;
				padding-left: 14px;
			}
		}

		&--text-field {
			label {
				color: map-get($colors, subheaderText) !important;
				font-family: map-get($fonts, open-light);
				font-size: 13px;
				height: 33px;
				left: 13px;
				line-height: 33px;
				top: 0px;
			}
		}

		&--select {
			.input-group__selections {
				border-right: 2px solid map-get($colors, grey-border);
				height: 27px;
				margin-top: 3px;

				&__comma {
					color: map-get($colors, subheaderText) !important;
					font-family: map-get($fonts, open-light);
					font-size: 13px;
					padding-left: 13px;
				}
			}
		}

		.input-group__append-icon {
			color: map-get($colors, subheaderText) !important;
			font-size: 28px;
			padding: 0px;
			width: 25px;
		}

		.input-group__details {
			display: none;
		}

		input::placeholder {
			color: color(text);
			font-family: font(AvenirRegular);
			font-size: size(medium);
			letter-spacing: -0.63px;
		}

		input:-ms-input-placeholder {
			color: color(text);
			font-family: font(AvenirRegular);
			font-size: size(medium);
			letter-spacing: -0.63px;
		}

		input::-webkit-input-placeholder {
			color: color(text);
			font-family: font(AvenirRegular);
			font-size: size(medium);
			letter-spacing: -0.63px;
		}

		input::-moz-placeholder {
			color: color(text);
			font-family: font(AvenirRegular);
			font-size: size(medium);
			letter-spacing: -0.63px;
		}

		&:focus {
			outline: none !important;
		}

		&:hover,
		&:focus {
			border: 1px solid #409aff;
		}

		&.v-input--is-disabled.v-input--is-readonly {
			border: 0px !important;
		}

		&.v-input--is-focused {
			border: 1px solid #409aff;
		}

		&.v-input--is-focused:not(.v-input--is-dirty) + .tooltip-on-focused {
			display: initial;
		}
	}

	&.input-group.input-group--multiple {
		height: auto;

		.input-group__selections {
			height: auto;
			margin: 0px;
			padding-left: 10px;
		}
	}

	&-content {
		.list {
			&__tile {
				color: map-get($colors, subheaderText);
				font-family: map-get($fonts, open-light);
				font-size: 13px;
				height: 33px;
			}
		}
	}
}

.show-error {
	.input-group__details {
		font-size: map-get($sizes, small10);
		display: block !important;
		padding-top: 0;
	}
	.input-group__details:before {
		height: 0px;
	}
}

.table-style {
	.table__overflow {
		.table {
			thead tr {
				background-color: map-get($colors, primary);
				height: 30px;
				th {
					color: white !important;
				}
			}
			tbody tr:nth-child(even) {
				background-color: map-get($colors, background-sidebar);
			}
		}
	}
}

.general-filter-button {
	.btn__content {
		justify-content: space-between;
		padding: 0px 8px 0px 13px;
	}
}

.header-page-download-document {
	.btn__content {
		padding: 0px;
	}
}

.modal-filter-footer {
	background-color: white;
	bottom: 0%;
	left: 0px;
	position: fixed;
	right: 0px;
	width: 100%;
	z-index: 2;
}

.filter-by-row {
	.input-group {
		padding-left: 18px;

		label {
			color: map-get($colors, subheaderText) !important;
			font-family: map-get($fonts, open-semibold);
			font-size: 13px;
			margin-left: 18px;
		}

		&__input {
			.icon {
				font-size: map-get($sizes, medium);
				height: 12px !important;
			}
		}
	}
}

.chip-exchange {
	.chip__content {
		height: 20px;
		letter-spacing: normal;
		line-height: 1;
		padding: 0px 10px;
		white-space: normal;
	}
}

.radio-group.sale-radio {
	.input-group {
		&__input {
			min-height: 19px;

			label {
				color: map-get($colors, subheaderText);
				font-size: map-get($sizes, medium);
				height: 19px;
				left: 16px;
				line-height: 19px;
			}

			.icon {
				font-size: map-get($sizes, small);
				height: 13px !important;
			}
		}

		&__details {
			display: none;
		}
	}

	&.radio-expansion-panel {
		&.input-group {
			padding: 5px 0px;
		}

		.input-group {
			&__input {
				display: flex;
				flex: 1 1 auto;
				flex-direction: row;
				flex-wrap: wrap;
				min-height: 19px;
				min-width: 0;

				label {
					color: map-get($colors, paginationText);
					font-size: 13px;
					height: 19px;
					left: 20px;
					line-height: 21px;
					text-transform: capitalize;
				}

				.icon {
					font-size: 16px;
					height: 16px !important;
				}
			}

			&__details {
				display: none;
			}
		}
	}

	.sale-radio-ticket {
		padding-left: 0px;
		padding-right: 44px;

		label {
			width: auto;
		}
	}

	.sale-radio-note {
		padding-left: 0px;
		padding-right: 16px;

		@media (min-width: 768px) {
			padding-right: 75px;
		}

		label {
			left: 16px;
		}
	}

	.sale-radio-bill {
		padding-right: 28px;
	}
}

.align-col-responsive {
	margin-bottom: 5px;
	text-align: left;

	@media (min-width: 768px) {
		margin-bottom: 0px;
		text-align: center;
	}
}

.pd-col-responsive {
	padding-left: 20px;

	@media (min-width: 768px) {
		padding-left: 0px;
	}
}

.btn-action-requeriment {
	border-radius: 5px !important;
	box-shadow: none !important;
	color: white !important;
	height: 30px !important;
	margin: 0px;
	text-transform: none !important;

	.btn__content {
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, small10);

		img {
			height: 20px;
			margin-left: 10px;
		}
	}
}

.btn-action-save {
	border: 1px solid map-get($colors, primary) !important;
	border-radius: 5px !important;
	box-shadow: none !important;
	color: map-get($colors, primary) !important;
	height: 30px !important;
	margin: 0px;
	text-transform: none !important;

	.btn__content {
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, small10);

		img {
			height: 20px;
			margin-left: 10px;
		}
	}
}

.btn-action {
	border-radius: 5px !important;
	box-shadow: none !important;
	color: map-get($colors, white) !important;
	height: 30px !important;
	margin: 0px;
	text-transform: none !important;
	width: 15px !important;

	.v-btn__content {
		color: map-get($colors, white) !important;
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, small10);
		padding: 0px;

		img {
			height: 20px;
			margin-left: 10px;
		}
	}

	&.text-large {
		.btn__content {
			font-family: map-get($fonts, open-bold);
			font-size: map-get($sizes, small);
		}
	}
}

.change-document-btn {
	.btn__content {
		padding: 0px;
	}
}

.overflow-auto {
	margin-top: 13px;
	overflow: auto;
	padding-bottom: 134px;
}

.options-menu {
	.btn__content {
		padding: 0px 2px;
	}

	button:hover {
		&:before {
			background-color: transparent !important;
		}
	}

	&-content {
		.list {
			border-radius: 4px;
			box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
			display: flex;
			padding: 0px;

			&__tile {
				height: 32px;
				padding: 0 8px;
			}
		}
	}
}

.progress-companies {
	.progress-linear__background {
		background-color: transparent !important;
	}
}

.notification {
	&-btn {
		.btn__content {
			padding: 0px;
		}
	}

	&-card {
		.btn__content {
			max-width: 100%;
			padding: 0px 0px 0px 17%;
			white-space: normal;
		}
	}
}

.theme--light {
	color: map-get($colors, black) !important;
	.table-icon {
		.btn__content {
			padding: 0px;
		}

		&.btn--disabled {
			&:not(.btn--icon):not(.btn--flat) {
				background-color: transparent !important;
				opacity: 0.6;
			}
		}
	}
}
.theme--light.v-icon {
    color: white !important;
}

.graphics-circular-legend-bar {
	.progress-linear__background {
		background-color: currentColor !important;
	}

	.progress-linear__bar__determinate {
		background-color: currentColor !important;
		border-radius: 4px !important;
	}
}
.filter-toggle {
	.btn {
		background-color: transparent !important;

		.btn__content {
			height: 28px;

			&:before {
				background-color: transparent !important;
			}
		}

		&.btn--disabled {
			&:not(.btn--icon):not(.btn--flat) {
				background-color: transparent !important;
			}

			.btn__content {
				&:before {
					background-color: transparent !important;
				}
			}
		}
	}
}

.dialog.dialog-cancel {
	border-radius: 10px;
	height: 237px;

	.card {
		height: 237px !important;
		padding: 32px 65px 22px;

		&__title {
			color: map-get($colors, paginationText);
			font-family: map-get($fonts, open-semibold);
			font-size: map-get($sizes, small);
		}
	}
}

.textarea-content {
	.input-group__input {
		border: 1px solid map-get($colors, grey-border) !important;
		border-radius: 0px !important;
		margin-bottom: 15px;
		max-height: 110px;
		padding: 0px !important;

		textarea {
			border-radius: 0px;
			color: map-get($colors, paginationText);
			font-family: map-get($fonts, open-regular);
			font-size: map-get($sizes, small);
			padding-left: 10px;
			padding-top: 10px !important;
		}
	}
}

button {
	min-width: 5px;
	outline: none;

	.table-icon {
		outline: none;
	}
}

.input-group--hide-details {
	.input-group__details {
		display: none;
	}
}

#calendar {
	padding: 0px 15px 15px;

	.fc {
		&-toolbar {
			&.fc-header-toolbar {
				margin-bottom: 0px;
			}
		}

		&-button {
			background-color: map-get($colors, background-sidebar);
			background-image: none;
			border: 1px solid map-get($colors, subheaderText);
			box-shadow: none;
			color: map-get($colors, subheaderText);
			font-family: map-get($fonts, open-regular);
			font-size: map-get($sizes, medium);
			height: 25px;
			line-height: map-get($sizes, medium);
			outline: none;
			text-shadow: none;

			&:first-child {
				border-bottom-left-radius: 5px;
				border-top-left-radius: 5px;
			}

			&:last-child {
				border-bottom-right-radius: 5px;
				border-top-right-radius: 5px;
			}
		}

		&-center {
			h2 {
				color: map-get($colors, subheaderText);
				font-family: map-get($fonts, regular);
				font-size: map-get($sizes, medium18);
			}
		}
	}
}

.title-form {
	color: map-get($colors, paginationText);
	font-family: map-get($fonts, open-semibold);
	font-size: 13px;
}

.hr-info {
	background-color: map-get($colors, blue-grey) !important;
}

.form-group__message {
	color: map-get($colors, orange-btn);
	font-family: map-get($fonts, open-semibold);
	font-size: 11px;
}
.pl-add-container {
	@include flex-center;
	background-color: map-get($colors, primary);
	border-radius: 5px;
	display: inline-flex;
	height: 20px;
	margin-right: 6px;
	width: 20px;
}

.btn-list {
	border-radius: 5px !important;
	box-shadow: none !important;
	height: 20px !important;
	min-width: 20px !important;

	&-add {
		border: 1px solid map-get($colors, primary);
		color: map-get($colors, primary) !important;
	}

	&-remove {
		border: 1px solid map-get($colors, orange-btn);
		color: map-get($colors, orange-btn) !important;
	}

	.btn__content {
		height: 18px;
		padding: 0px;
	}

	.icon {
		font-size: 20px;
	}
}

.custom-loader {
	animation: loader 1s infinite;
	display: flex;
}

.tabs__container--overflow .tabs__div.customer-tabs {
	flex: 0 1 auto;
}

@-moz-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
@-webkit-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
@-o-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
@keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
.size {
	cursor: pointer;
	height: 30px;
	width: 30px;
}
.fast-register-footer {
	background-color: white;
	bottom: 0%;
	position: fixed;
	width: 100%;
}

.expansion-panel-component {
	.expansion-panel {
		&__header {
			background-color: map-get($map: $colors, $key: expansion-panel-header);
			color: white;
			font-family: map-get($map: $fonts, $key: open-semibold);
			font-size: 13px;
			height: 30px;
			line-height: 1.2;
			padding: 0px 0px 0px 34px;
			text-transform: capitalize;
		}

		&__container .header__icon {
			border-left: 1px solid white;
			height: 30px;
		}

		&__container .header__icon .icon {
			color: white !important;
			font-size: 44px;
			height: 30px;
			line-height: 0.7;
		}
	}
}

.row-background-grey {
	background-color: map-get($map: $colors, $key: background-table);
}
.feature-footer {
	background-color: white;
	bottom: 0;
	position: absolute;
	width: 100%;
}

.input-group--error {
	border: 1px solid !important;
	box-shadow: none !important;
}

.login-input {
	color: map-get($colors, text) !important;

	.v-input__control .v-input__slot {
		min-height: auto !important;

		.v-input__prepend-inner {
			margin-top: 12px !important;

			.v-icon {
				color: map-get($colors, grey-icon) !important;
			}
		}

		.v-text-field__slot	{
			input {
				font-size: 14px !important;
				margin-top: 0px !important;
				max-height: 100% !important;
			}

			label {
				color: map-get($colors, text) !important;
				top: 15px !important;

				&.v-label--active {
					transform: translateY(-13px) scale(.75);
				}
			}
		}
	}
}

.confirmation-dialog {
	border-radius: 20px !important;
}

.cyan--text {
	color: #00add4 !important;
}

.switch-period {
	.v-input--selection-controls__input {
		margin-right: 0px !important;
	}
}

.v-text-field.v-text-field--solo .v-input__control {
	min-height: auto !important;
}

.btn-auto {
	min-width: auto !important;

	&.btn-action {
		height: auto !important;
		width: auto !important;
	}
}

.check-table {
	.v-input--selection-controls__input {
		margin-right: 0px !important;
	}
}

.switch-rule {
	color: map-get($colors, error) !important;

	.v-input--switch__track:not(.success--text) {
		color: map-get($colors, error) !important;
	}

	.v-input--switch__thumb:not(.success--text) {
		color: map-get($colors, error) !important;
	}
}

@media print {
	.media-print {
		display: none !important;
	}
}

.radio-filter-by {
	.v-input--selection-controls__input {
		margin-right: 16px;
		height: 14px;
		width: 14px;
	}

	.v-input--selection-controls__ripple {
		height: 12px;
		left: -6px;
		top: -6px;
		width: 12px;
	}

	.v-icon {
		font-size: map-get($sizes, medium);
		height: 14px;
	}

	.v-label {
		font-family: map-get($fonts, open-regular);
		font-size: map-get($sizes, medium);
	}
}
.mx-datepicker.date-component-round {
	.mx-input {
		border: 1px solid #02979b !important;
		font-family: 'AvenirBold';
		border-radius: 19px !important;
		box-shadow: none !important;
		padding: 0px 10px !important;
		color: #02979b !important;
	}

	.mx-icon-clear {
		right: 4px !important;
		top: 52% !important;
	}
}
.header-select {
	.v-select__selections {
		color: #02979b !important;
		font-size: small;
		font-family: "AvenirBold";
		white-space: nowrap !important;
		overflow: hidden !important;
		text-overflow: ellipsis !important;
		display: block !important;
		max-width: 100% !important;
	}
	.v-select__selections {
		color: #02979b !important;
		font-size: size(small);
		font-family: "AvenirBold";
		.v-select__selection, .v-select__selection--comma {
			white-space: nowrap !important;
		}
	}

	.v-input__control > .v-input__slot {
		border: 1px solid #02979b  !important;
		border-radius: 999px !important;
		box-shadow: none !important;
		@media (max-width: 768px) {
			border: 0px solid !important;
			width: 240px !important;
		}
	}

}
.base-select {
	.v-select__selections {
		color: color(text) !important;
		font-family: map-get($fonts, AvenirRegular) !important;
		font-size: size(small) !important;
	}

	.v-input__control > .v-input__slot {
		background-color: color(white);
		border: 1px solid PowderBlue !important;
		border-radius: 5px !important;
		box-shadow: none !important;
		font-family: map-get($fonts, AvenirRegular) !important;
		font-size: size(small) !important;
		padding-left: 13px;

		label {
			color: color(grey-text) !important;
			font-size: size(small) !important;
			font-family: map-get($fonts, AvenirRegular) !important;
		}

		&::before {
			display: none !important;
		}

		&::after {
			display: none !important;
		}

		.v-label--active {
			transform: translateY(-26px) scale(0.75) !important;
		}

		.theme--light.v-icon {
			color: #006edb !important;
		}
	}
}

.base-input {

	.v-input__control > .v-input__slot {
		border: 1px solid PowderBlue !important;
		border-radius: 5px !important;
		box-shadow: none !important;
		min-height: 0;

		label {
			font-size: size(small) !important;
			font-family: map-get($fonts, AvenirRegular) !important;
			left: 12px !important;
			top: 7px !important;
			color: color(text) !important;
		}

		input {
			color: color(text) !important;
		}

		.v-label--active {
			transform: translateY(-26px) scale(0.75) !important;
		}

		&::before {
			display: none !important;
		}

		&::after {
			display: none !important;
		}

		.v-text-field__slot {
			padding-left: 13px !important;
		}
	}
}

.base-input:read-only {

	.v-input__control > .v-input__slot {
		background-color: white !important;
	}
}

.no-movil {
	@media (max-width: 768px) {
		display: none;
	}
}

.add-btn-icon {

	.material-icons {
		font-size: 28px !important;
	}
}

.add-btn-container {
	height: 24px;
	width: 28px;

	.material-icons {
		font-size: 24px !important;
	}

	@media (min-width: 768px) {
		height: 30px;
		width: 30px;

		.material-icons {
			font-size: 28px !important;
		}
	}
}

.error-style {
	color: color(error);
	margin-left: 15px;
}

.check-base {
	&.v-input--selection-controls {
		margin-top: 0 !important;
		padding-top: 0 !important;
	}
	.v-input__slot {
		margin-bottom: 0 !important;
	}
}

.page-dictionary {
	.v-tabs__wrgitapper {
		position: relative;
		right: 40px;
	}

	.v-tabs__item--active {
		color: map-get($colors, green-icon);
		font-family: map-get($fonts, open-bold);
		font-size: map-get($sizes, medium);
		padding: 0 !important;
	}

	.v-tabs__div {
		color: map-get($colors, grey-icon) !important;
	}

	.v-tabs__item {
		@media (max-width: 768px) {
			width: 100%;
		}
	}

	.v-tabs__div {
		@media (max-width: 768px) {
			width: 100%;
		}
	}
}
.accounting-searcher {
	.error-style {
		display: none;
  }
}

.accounting-switch {
	label {
		font-family: font(AvenirDemi);
		font-size: size(medium18);
	}
}

.accounting-switch-normal {
	label {
		font-family: font(AvenirDemi);
		font-size: size(medium16);
	}
}

.isLoading {
	background-color: color(grey-background-filter);
	border-radius: 99px;
	height: 40px;
}

.fade-enter-active, .fade-leave-active {
	transition: opacity 1s;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
}

.text-area {
	.v-input__control {
		border: 1px solid color(grey-icon) !important;
		border-radius: 20px !important;

		.v-input__slot {
			border-radius: 20px !important;
		}
	}
}

.isLoading {
	background-color: color(grey-background-filter);
	border-radius: 99px;
	height: 40px;
}

.fade-enter-active, .fade-leave-active {
	transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.text-area {
	.v-input__control {
		border: 1px solid color(grey-icon) !important;
		border-radius: 20px !important;

		.v-input__slot {
			border-radius: 20px !important;
		}
	}

}

.header-responsive {
	@media (max-width: 954px) {
		.v-toolbar__content {
			padding: 0px !important;
			background-color: #02979b !important;
		}
	}
}

.action-mobile {
	@media (max-width: 768px) {
		display: none;
	}
}

.action-bar-container {
	@media (max-width: 768px) {
		.v-btn__content {
			justify-content: flex-start;
		}
	}
}

.action-table-responsive {
	@media (max-width: 768px) {
		button {
			margin: 0px !important;

			img {
				width: 80% !important;
			}
		}
	}
}

@media (max-width: 768px) {
	.company-list {
		.movil-table th:not(.column-movil-version) {
			display: flex;
			grid-column: 1/3;
			grid-row: 1;

			&#column-1 {
				grid-column: 2/8;
			}

			&#column-3 {
				grid-column: 10/14;
			}
		}
	}

	.page-cost-center {
		.movil-table th:not(.column-movil-version) {
			display: flex;
			grid-row: 1;

			&#column-1 {
				justify-content: center;
			}

			&#column-2 {
				grid-column: 2/5;
				justify-content: center;
			}

			&#column-3 {
				justify-content: center;
			}
		}
	}
}

.fs-10 {
	font-size: 10px;
}

.journal-filter {
	.date-form {
		width: 155px;
	}
}

.text-edit-mobile {
	color: map-get($colors, btn-green);
	font-family: map-get($fonts, AvenirRegular);
	font-size: 11px;
}

.text-delete-mobile {
	color: map-get($colors, text-red-light);
	font-family: map-get($fonts, AvenirRegular);
	font-size: 11px;
}

.v-content {
	@media (max-width: 768px) {
		padding: 40px 0px 0px 0px !important;
	}
	.v-content__wrap {
		background: #f1f4fa;
	}
}

.overlay-menu {
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	background: #212121;
	z-index: 1;
	opacity: 0.46;

	@media (min-width: 768px) {
		display: none;
	}
}

.text-edit-mobile {
	color: map-get($colors, btn-green);
	font-family: map-get($fonts, AvenirRegular);
	font-size: 11px;
}

.text-delete-mobile {
	color: map-get($colors, text-red-light);
	font-family: map-get($fonts, AvenirRegular);
	font-size: 11px;
}

.text-action-blue {
	color: #006edb;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 11px;
}

.accounting-by-subsidiary {
	@media (max-width: 768px) {
		.flex .header-table-text .text-xs-center .xs2 {
			display: none;
		}
	}
}

.base-textarea {
	.v-input__control > .v-input__slot {
		border: 1px solid color(grey-icon) !important;
		border-radius: 30px !important;
		box-shadow: none !important;
		min-height: 0;

		label {
			color: color(grey-text) !important;
		}

		input {
			color: color(text) !important;
		}
	}
}

.search-input {
	.icon-search-input {
		color: #a9bac2 !important;
	}
}

.journal-detail {
	.search-input {
		width: 580px !important;
	}
}

.select-autocomplete-create.v-input,
.filter-select.v-input {
	.v-input__slot:before {
		content: none !important;
	}
}

.select-autocomplete-create.v-input {
	.v-select__selections {
		padding-left: 14px;
	}

	.material-icons {
		color: color(secondary) !important;
	}

	input {
		padding-left: 0px !important;
	}
}

.mx-datepicker {
	.mx-input {
		border: 1px solid color(grey-icon);
		box-shadow: none !important;
		height: 31px !important;

		&::placeholder {
			color: color(text);
			font-family: font(AvenirRegular);
			font-size: size(medium);
			letter-spacing: -0.63px;
		}

		&::-moz-placeholder {
			color: color(text);
			font-family: font(AvenirRegular);
			font-size: size(medium);
			letter-spacing: -0.63px;
		}

		&::-webkit-input-placeholder {
			color: color(text);
			font-family: font(AvenirRegular);
			font-size: size(medium);
			letter-spacing: -0.63px;
		}

		&:-ms-input-placeholder {
			color: color(text);
			font-family: font(AvenirRegular);
			font-size: size(medium);
			letter-spacing: -0.63px;
		}
	}
}

.edit-inline {
	.v-input {
		height: 22px !important;

		.v-select__slot {
			height: 22px !important;

			&:after {
				content: none;
			}
		}

		.v-select__selections {
			padding-left: 0px !important;
		}

		.v-input__append-inner {
			height: 22px !important;
			margin-top: 0px !important;
			padding-left: 0px;
			padding-right: 5px;
			width: 22px !important;
		}

		.input-group__selections__comma {
			font-family: font(AvenirRegular) !important;
			font-size: size(small11) !important;
			padding-left: 7px;
		}

		input {
			font-family: font(AvenirRegular) !important;
			font-size: size(small11) !important;
			height: 22px !important;
			padding: 0px 0px 0px 7px !important;

			&::placeholder {
				font-family: font(AvenirRegular);
				font-size: size(small11);
			}

			&::-moz-placeholder {
				font-family: font(AvenirRegular);
				font-size: size(small11);
			}

			&:-ms-input-placeholder {
				font-family: font(AvenirRegular);
				font-size: size(small11);
			}

			&::-webkit-input-placeholder {
				font-family: font(AvenirRegular);
				font-size: size(small11);
			}
		}
	}
}

.company-modules-route {

	.v-list__tile {
		color: #02979b  !important;
		font-family: font(AvenirRegular);
	}
}
v-list__tile theme--light

.date-picker-input {
	.input-group.input-group--solo label {
		border: 1px solid #a9bac2 !important;
		border-radius: 5px !important;
		font-size: size(small);
		top: 0;
	}
}

.app-date-select {
	.v-text-field__details {
		display: none !important;
	}

	.v-input__slot {
		border: 1px solid #a9bac2 !important;
		box-shadow: none !important;
		border-radius: 5px !important;
		height: 32px;
	}

	.theme--light.v-icon {
		color: #006edb !important;;
	}

	.theme--light.v-label {
		color: #858585 !important;
		font-family: map-get($fonts, AvenirRegular) !important;
		font-size: 14px !important;
	}

	.v-text-field input {
		color: #858585 !important;
		font-family: map-get($fonts, AvenirRegular) !important;
		font-size: 14px !important;
	}
}

.page-accounting-action {
	.app-btn .blue {
		background: #a9bac2 !important;
	}
}

.dialog-loading {
	box-shadow: none !important;
	text-align: center;
}
.tree-node {
	.slot-node-content {
		border-bottom: 1px solid #02979b;
	}

	.node {
		background-color: color(gray-light);
	}
}
.filter-select-custom {
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 5px !important;
    min-height: 25px !important;

    position: relative;
    z-index: 1;

    border: 0.5px solid #a9bac2;
    font-size: size(small) !important;

    overflow: visible !important;
}


/* =========================================================
   SELECT ACTIVO
========================================================= */

.filter-select-custom.multiselect.multiselect--active {
    z-index: 99999 !important;
}


/* =========================================================
   CONTENIDO DEL SELECT
========================================================= */

.filter-select-custom.multiselect
.multiselect__content-wrapper {
    position: absolute !important;
    z-index: 99999 !important;

    width: fit-content;
    min-width: 100%;

    overflow-x: hidden;
}


/* =========================================================
   PLACEHOLDER / TAGS / SINGLE
========================================================= */

.filter-select-custom.multiselect
.multiselect__placeholder,

.filter-select-custom.multiselect
.multiselect__tags,

.filter-select-custom.multiselect
.multiselect__single {
    min-height: 25px !important;
    padding: 1px 40px 0 1px !important;
    font-size: size(small);

    margin-bottom: 0;
}


/* =========================================================
   FLECHA
========================================================= */

.filter-select-custom.multiselect
.multiselect__select,

.filter-select-custom.multiselect
.multiselect__select--active {
    height: 25px;
    padding: 10px 6px;
    font-size: size(small);
}


/* =========================================================
   FLECHA - BEFORE / AFTER
========================================================= */

.filter-select-custom.multiselect
.multiselect__select::before,

.filter-select-custom.multiselect
.multiselect__select::after {
    top: 6px !important;
}


/* =========================================================
   OPCIONES
========================================================= */

.filter-select-custom.multiselect
.multiselect__option {
    padding: 6px 12px;
    min-height: 25px;
}


/* =========================================================
   OPCIÓN HOVER
========================================================= */

.filter-select-custom.multiselect
.multiselect__option--highlight {
    background: #33cfc7 !important;
}


/* =========================================================
   OPCIÓN SELECCIONADA
========================================================= */

.filter-select-custom.multiselect
.multiselect__option--selected {
    background: color(background-card);
}
.item-list-disabled {
	text-decoration: line-through;
	color: #aaa;
	cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/App.vue